import $ from 'jquery'
import global from '../../cms/modules/global'
import iframe from '../../front/modules/iframe'

function init() {
    if (!$('body').hasClass('broker_calculator')) {
        return;
    }

    setUpEventListeners()
    events.onRateCheckboxChange()
}

function setUpEventListeners() {
    $('body.results #filters #apply_button').on('click', events.onFiltersApplyButtonClick)
    $('#rates__container').on('change', '.rate [type=checkbox]', events.onRateCheckboxChange)
    $('#download_button').on('click', events.onDownloadButtonClick)
    $('#email_form #send_email_button').on('click', events.onSendEmailButtonClick)
    $('#rates__header a.select-all').on('click', events.onRatesHeaderSelectAllButtonClick)
    $('#how_to_use_button').on('click', events.onHowToUseButtonClick)
    $('#video_modal .confirm-button').on('click', events.onVideoModalConfirmButtonClick)
}

const events = {
    onFiltersApplyButtonClick: (e) => {
        const rates = $('#rates'),
            rates_container = $('#rates__container'),
            entry_id = $('#filters').data('entry-id'),
            carrier_ids = $('[name=filter_carrier]:checked').
                map(function() { return $(this).val() }).
                get().
                join(','),
            tier_ids = $('[name=filter_tier]:checked').
                map(function() { return $(this).val() }).
                get().
                join(','),
            pay_period = $('[name=filter_pay_period]:checked').val()

        e.preventDefault()
        rates.addClass('loading')
        rates_container.html('')

        $.getJSON(
            '/broker_calculator/filter_plans',
            {
                entry_id: entry_id,
                carrier_ids: carrier_ids,
                tier_ids: tier_ids,
                pay_period: pay_period
            },
            (response) => {
                setTimeout(() => {
                    if (response.success) {
                        rates_container.html( response.html )
                    }

                    rates.removeClass('loading')
                    events.onRateCheckboxChange()
                    iframe.postContentHeightToParent()
                }, global.LOAD_DELAY_TIME)
            }
        )
    },
    onRateCheckboxChange: () => {
        const download_button = $('#download_button'),
            send_email_button = $('#send_email_button'),
            num_rates = $('.rate [type=checkbox]:checked').length

        download_button.toggleClass('disabled', num_rates == 0)
        send_email_button.toggleClass('disabled', num_rates == 0)
    },
    onDownloadButtonClick: (e) => {
        const a = $(e.currentTarget),
            href = a.attr('href'),
            rate_ids = $('.rate [type=checkbox]:checked').
                map(function() { return $(this).val() }).
                get().
                join(','),
            pay_period = $('[name=filter_pay_period]:checked').val(),
            url = href + '?rate_ids=' + rate_ids + '&pay_period=' + pay_period

        e.preventDefault()
        console.log(url)
        window.location = url
    },
    onSendEmailButtonClick: (e) => {
        const btn = $(e.currentTarget),
            btn_text = btn.find('.text'),
            name = $('#recipient_name').val(),
            email = $('#recipient_email_address').val(),
            entry_id = $('#filters').data('entry-id'),
            rate_ids = $('.rate [type=checkbox]:checked').
                map(function() { return $(this).val() }).
                get().
                join(','),
            pay_period = $('[name=filter_pay_period]:checked').val()

        e.preventDefault()
        btn.addClass('disabled')
        btn_text.html('SENDING&hellip;')

        $.getJSON(
            '/broker_calculator/send_email',
            {
                entry_id: entry_id,
                name: name,
                email: email,
                rate_ids: rate_ids,
                pay_period: pay_period
            },
            (response) => {
                setTimeout(() => {
                    if (response.success) {
                        btn_text.html('SENT!')
                    } else {
                        btn_text.html('ERROR!')
                    }

                    setTimeout(() => {
                        btn.removeClass('disabled')
                        btn_text.html('EMAIL RATE SHEET')
                    }, global.LOAD_DELAY_TIME * 2)
                }, global.LOAD_DELAY_TIME)
            }
        )
    },
    onRatesHeaderSelectAllButtonClick: (e) => {
        e.preventDefault();
        $('#rates__container .rate').find('input[type=checkbox]').prop('checked', 'checked');
        events.onRateCheckboxChange();
    },
    onHowToUseButtonClick() {
        const body = $('body')

        body.addClass('modal-showing')
        iframe.postContentHeightToParent()
    },
    onVideoModalConfirmButtonClick() {
        const body = $('body')

        body.removeClass('modal-showing')
        iframe.postContentHeightToParent()
    }
}

export default { init }